import {
  AuthenticationContext,
  adalFetch,
  withAdalLogin} from "react-adal";
import { getCurrentEnvironment } from "../constants/api";

export const adalConfig = {
 // tenant: "72446be9-a454-4bfa-87d4-8cf4f6eaaf39",
  tenant: "f95c84a5-39e6-4aca-ba21-2159ab4b5a0a",
  //clientId: "2b1e537e-9f0d-46ba-b4de-291a3948181a",
  clientId: getCurrentEnvironment().clientId,
  endpoints: {
   // api: "https://STREAMREALTY.onmicrosoft.com/TestAPI",
    api: "https://login.microsoftonline.com/f95c84a5-39e6-4aca-ba21-2159ab4b5a0a"
  },
  cacheLocation: "localStorage",
  loadFrameTimeout: 15,
  //endpoints:
  expireOffsetSeconds: 120,
  callback: callbackTokenAcquired
};

/** Call back token Acquired */
function callbackTokenAcquired(TokenCallback) {
  console.log("tokenCallBack", TokenCallback);
}

export const authContext = new AuthenticationContext(adalConfig);

export const adalApiFetch = (fetch, url, options) =>
  adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);

export const withAdalLoginApi = withAdalLogin(
  authContext,
  adalConfig.endpoints.api
);
